module.exports = __webpack_public_path__ + "static/media/img73_R.2339ed96.jpg";